export const OFFERINGS_DATA = "OFFERINGS_DATA";
export const OFFERINGS_START_LOADER = "OFFERINGS_START_LOADER";
export const OFFERINGS_STOP_LOADER = "OFFERINGS_STOP_LOADER";
export const OFFERINGS_HIDE_ERROR = "OFFERINGS_HIDE_ERROR";
export const OFFERINGS_SET_ERROR = "OFFERINGS_SET_ERROR";
